var streetList=[
    {
        name:'广文街道',
        code:'GW',
        id:"1"
    },
    {
        name:'北海路街道',
        code:'BHL',
        id:"2"
    },
    {
        name:'廿里堡街道',
        code:'NLB',
        id:"3"
    },
    {
        name:'潍州路街道',
        code:'WZL',
        id:"4"
    },
    {
        name:'梨园街道',
        code:'LY',
        id:"5"
    },
    {
        name:'大虞街道',
        code:'DY',
        id:"6"
    },
    {
        name:'东关街道',
        code:'DG',
        id:"7"
    },
    {
        name:'北苑街道',
        code:'BY',
        id:"8"
    }
]

export default streetList